module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_12_m.2c8144aea9329d0afdd1dc958252c003.png";